import { render, staticRenderFns } from "./GastroEnteroscopiaList.vue?vue&type=template&id=4ffad80f"
import script from "./GastroEnteroscopiaList.vue?vue&type=script&lang=js"
export * from "./GastroEnteroscopiaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports